import { Box, Heading, Text, Wrap, WrapItem } from '@chakra-ui/react'
import React from 'react'
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts'
import { FeedbackSummary } from '../../types/analyticsTypes'

interface FeedbackDonutChartProps {
  summary: FeedbackSummary
}

const COLORS = {
  good: '#38A169',
  neutral: '#A0AEC0',
  bad: '#E53E3E',
}

const FeedbackDonutChart: React.FC<FeedbackDonutChartProps> = ({ summary }) => {
  const data = [
    { key: 'good', label: 'Thumbs up', value: summary.good, percentage: summary.good_percentage, color: COLORS.good },
    { key: 'neutral', label: 'No feedback', value: summary.neutral, percentage: summary.neutral_percentage, color: COLORS.neutral },
    { key: 'bad', label: 'Thumbs down', value: summary.bad, percentage: summary.bad_percentage, color: COLORS.bad },
  ]

  return (
    <Box bg='white' borderWidth='1px' borderColor='gray.200' borderRadius='lg' p={5}>
      <Heading size='sm' mb={1}>
        Feedback distribution
      </Heading>
      <Text fontSize='sm' color='gray.500' mb={4}>
        All answers, {summary.total} total
      </Text>
      {summary.total === 0 ? (
        <Text color='gray.500'>No answers yet.</Text>
      ) : (
        <>
          <Box position='relative' height='260px'>
            <ResponsiveContainer width='100%' height='100%'>
              <PieChart>
                <Pie
                  data={data}
                  dataKey='value'
                  nameKey='label'
                  cx='50%'
                  cy='50%'
                  innerRadius={60}
                  outerRadius={90}
                >
                  {data.map(entry => (
                    <Cell key={entry.key} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip
                  formatter={(value, _name, item) => [
                    `${value} (${item?.payload?.percentage}%)`,
                    item?.payload?.label,
                  ]}
                />
              </PieChart>
            </ResponsiveContainer>
            <Box
              position='absolute'
              top='50%'
              left='50%'
              transform='translate(-50%, -50%)'
              textAlign='center'
              pointerEvents='none'
            >
              <Text fontSize='2xl' fontWeight='bold' lineHeight='1'>
                {summary.total}
              </Text>
              <Text fontSize='xs' color='gray.500'>
                answers
              </Text>
            </Box>
          </Box>
          <Wrap spacing={4} justify='center' mt={4}>
            {data.map(entry => (
              <WrapItem key={entry.key} alignItems='center'>
                <Box w='10px' h='10px' borderRadius='sm' bg={entry.color} mr={2} />
                <Text fontSize='sm' color='gray.600'>
                  {entry.label}: {entry.value} ({entry.percentage}%)
                </Text>
              </WrapItem>
            ))}
          </Wrap>
        </>
      )}
    </Box>
  )
}

export default FeedbackDonutChart
